<app-sub-menu [subMenus]="subMenus"></app-sub-menu>

<div class="container-fluid bg-box">

    <div class="container-fluid bg-box">
        <button class="btn btn-sm btn-success mb-2" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample"><i class="fa fa-search"></i>
            Aplicar filtros
        </button>
        <div class="collapse" id="collapseExample">
            <div class="card card-body">
                <form id="formSearch" (submit)="formSearch($event)">

                    <div class="row">
                        <div class="col-sm-6 col-lg-6">
                            <div class="form-group">
                                <label for="FechaInicio">Fecha inicio</label>
                                <input name="FechaInicio" type="date" class="form-control" [(ngModel)]="FechaInicio">
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-6">
                            <div class="form-group">
                                <label for="FechaFin">Fecha fin</label>
                                <input name="FechaFin" type="date" class="form-control" [(ngModel)]="FechaFin">
                            </div>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col-12 d-flex justify-content-end">
                            <button class="btn btn-sm btn-primary" type="submit"><i class="fa fa-search"></i>
                                Buscar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <hr>
    <div class="row">
        <div class="col-12">
            <div class="table-responsive">
                <table id="table" class="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th scope="col">Log</th>
                            <th scope="col">Id Cliente</th>
                            <th scope="col">Host Name</th>
                            <th scope="col">Método</th>
                            <th scope="col">Mensaje</th>
                            <th scope="col">Aplicación</th>
                            <th scope="col">Fecha</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of logs">
                            <td>{{item.IdLog}}</td>
                            <td>{{item.IpClient}}</td>
                            <td>{{item.HostName}}</td>
                            <td>{{item.Method}}</td>
                            <td>{{item.Trace}}</td>
                            <td>{{item.IdTipoAplicacion}}</td>
                            <td>{{item.FechaAlta}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>